'use strict';

exports.__esModule = true;
exports.videoTypes = undefined;
exports.getVideoUrl = getVideoUrl;
exports.getVideoDataFromUrl = getVideoDataFromUrl;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _dailymotionVideoUtils = require('./dailymotionVideoUtils');

var dailymotionVideoUtils = _interopRequireWildcard(_dailymotionVideoUtils);

var _facebookVideoUtils = require('./facebookVideoUtils');

var facebookVideoUtils = _interopRequireWildcard(_facebookVideoUtils);

var _vimeoVideoUtils = require('./vimeoVideoUtils');

var vimeoVideoUtils = _interopRequireWildcard(_vimeoVideoUtils);

var _youtubeVideoUtils = require('./youtubeVideoUtils');

var youtubeVideoUtils = _interopRequireWildcard(_youtubeVideoUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: unite with santa viewer

var VIDEO_UTILS_PROVIDERS = {
  YOUTUBE: youtubeVideoUtils,
  VIMEO: vimeoVideoUtils,
  DAILYMOTION: dailymotionVideoUtils,
  FACEBOOK: facebookVideoUtils
};

function getMethodForType(videoType, methodName) {
  return VIDEO_UTILS_PROVIDERS[videoType.toUpperCase()] && VIDEO_UTILS_PROVIDERS[videoType][methodName];
}

/**
 * @param {{videoType: string, videoId: string}} videoData
 * @returns {string}
 */
function getVideoUrl(videoData) {
  if (videoData && videoData.videoType && videoData.videoId) {
    var videoUrlGetter = getMethodForType(videoData.videoType, 'getVideoUrl');
    return videoUrlGetter && videoUrlGetter(videoData.videoId) || '';
  }

  return '';
}

/**
 * @param {string} videoUrl
 * @returns {videoData}
 */
function getVideoDataFromUrl(videoUrl) {
  var videoData = void 0;
  _lodash2.default.forEach(VIDEO_UTILS_PROVIDERS, function (methods, videoType) {
    var videoIdGetter = getMethodForType(videoType, 'getVideoIdFromUrl');
    var videoId = videoIdGetter && videoIdGetter(videoUrl);
    if (!_lodash2.default.isEmpty(videoId)) {
      videoData = {
        videoType: videoType,
        videoId: videoId
      };
      return false; // break forEach
    }
  });
  return videoData;
}

var videoTypes = exports.videoTypes = {
  YOUTUBE: 'YOUTUBE',
  VIMEO: 'VIMEO',
  DAILYMOTION: 'DAILYMOTION',
  FACEBOOK: 'FACEBOOK'
};
//# sourceMappingURL=videoUrlsUtils.js.map